<template>
  <div v-if="title || items" class="product-block" :class="additionalClass">
    <div class="product-block__inner">
      <h3 v-if="title" class="product-block__title main-heading">{{ title }}</h3>
      <product-items v-if="items" :items="items" :class="{ 'product-items_no-top-padding': !title }" />
    </div>
  </div>
</template>

<script>
  import ProductItems from '~/components/product/ProductItems.vue';

  export default {
    components: {
      ProductItems
    },
    props: {
      title: {
        default: '',
        type: String
      },
      additionalClass: {
        default: '',
        type: String
      },
      items: {
        default() {
          return [];
        },
        type: Array
      },
      // we get these props but don't use them in current block type
      publishedTo: {
        default: undefined,
        type: [Number, String]
      },
      nodes: {
        default() {
          return [];
        },
        type: Array
      },
      content: {
        default() {
          return {};
        },
        type: Object
      },
      video: {
        default() {
          return {};
        },
        type: Object
      },
      placeholder: {
        default() {
          return {};
        },
        type: Object
      },
      images: {
        default() {
          return [];
        },
        type: Array
      }
    }
  };
</script>
